module.exports = __webpack_public_path__ + "static/media/pt-BR.03880cc3.md";